<script>
import appConfig from "@/app.config.json";
import Layout from "@/views/layouts/main.vue";
import DatePicker from "vue2-datepicker";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";
import { datetime } from "@/filters/index"
import sweetAlert from "@/mixins/sweetAlert";

export default {
  name: "ManifestAttach",
  page: {
    title: "マニフェスト紐付",
    meta: [{ name: "description", content: appConfig.description }]
  },
  mixins: [ sweetAlert ],
  components: {
    Layout,
    DatePicker,
    CommonTableComponent
  },
  data() {
    return {
      manifests: [],
      dataSelected: [],
      isLoading: false,
      manifest2ndId: "",
      manifest2nd: {},
      filters: {
        manifest_type_cd: "",
        discharger_name: "",
        discharger_site_name: "",
        disposal_vendor_site_name: "",
        start_datetime: "",
        end_datetime: ""
      },
      headers: [
        {
          text: "",
        },
        {
          text: "1次マニフェスト番号",
          width: 170,
        },
        {
          text: "媒体",
          width: 55
        },
        {
          text: "受入量",
          width: 85
        },
        {
          text: "単位",
          width: 55
        },
        {
          text: "処分終了日",
          width: 120
        },
        {
          text: "廃棄物名/廃棄物種類",
        },
        {
          text: "排出事業者/事業場",
        },
        {
          text: "処分事業場",
        }
      ],
    };
  },
  created() {
    if (this.$router.currentRoute.params.id) {
      this.manifest2ndId = this.$router.currentRoute.params.id;
      this.filters.start_datetime = this.$router.currentRoute.params.date_of_issue;
      this.filters.end_datetime = this.$router.currentRoute.params.date_of_issue;
      this.getManifest2nd();
    }
  },
  methods: {
    async getManifest2nd() {
      const url = apiEndpoints.detail_manifest_attach(this.manifest2ndId); //ManifestController.show
      const { status, data } = await this.$http.get(url);
      if (status) {
        this.manifest2nd = data.result;
        const dateOfIssue = data.result.waste_or_service_daily_report[0].date_of_issue;
        this.filters.end_datetime = dateOfIssue;
        const startDate = new Date(dateOfIssue);
        startDate.setDate(startDate.getDate() - 180);
        this.filters.start_datetime = startDate.toISOString().slice(0, 10);
        this.onSearch();
      }
    },
    async onSearch() {
      this.isLoading = true;
      const params = {
          ...this.filters,
          manifest_id_2nd: parseInt(this.manifest2ndId),
          number_of_issue_2nd: this.manifest2nd.number_of_issue,
          discharger_registration_number_2nd: this.manifest2nd.discharger_registration_number,
          disposal_vendor_registration_number_2nd: this.manifest2nd.sub_disposal_vendor_registration_number,
          disposal_vendor_id_2nd: this.manifest2nd.waste_or_service_daily_report[0].vendor_site_id,
          waste_category_cd_2nd: this.manifest2nd.waste_category_cd,
      };
      const { status, data } = await this.$http.post(apiEndpoints.list_manifests_attach, params);
      if (status) {
        this.manifests = this.transferData(data.result);
      } else {
        this.errorToast(data.message, false, 5000, "top-end");
        this.manifests = [];
      }
      this.isLoading = false;
    },
    transferData(data) {
      if (data.length === 0) {
        return [];
      }

      const valueToTextMap = new Map(this.zzManifestTypes.map(item => [item.value, item.text]));

      return data.map(item => {
        const formattedDate = datetime(item.sub_disposal_vendor_end_date, "YYYY/MM/DD");
        const typeCdText = valueToTextMap.get(parseInt(item.manifest_type_cd)) || item.manifest_type_cd;

        item.manifest1st_by_manifest2nd.forEach(subItem => {
          if (subItem.manifest_id_2nd === parseInt(this.manifest2ndId)) {
            if (!this.dataSelected.includes(item.id)) {
              this.dataSelected.push(item.id);
            }
          }
        });

        return {
          ...item,
          sub_disposal_vendor_end_date: formattedDate,
          manifest_type_cd: typeCdText
        };
      });
    },
    async onSelect() {
      const params = {
        manifest_id_2nd: parseInt(this.manifest2ndId),
        manifest_id_1sts: this.dataSelected
      };
      const { status, data } = await this.$http.post(apiEndpoints.attach_manifests, params);
      if (status) {
        return this.backToList();
      }

      return this.errorToast(data.message);
    },
    onClear() {
      for (let key in this.filters) {
        if (this.filters.hasOwnProperty(key)) {
          this.filters[key] = "";
        }
      }

      this.onSearch()
    },
    backToList() {
      if (!this.manifest2ndId) {
        return;
      }

      this.$router.push({
        name: "manifests.edit",
        params: { id: this.manifest2ndId },
      });
    },
    getUnitName(item){
      const jwUnits = this.$store.getters['options/options_tables'].zz_jw_units ?? [];

      let name = jwUnits.filter(o => {
        return o.id == item.sub_disposal_vendor_disposal_unit
      });
      if(name.length > 0) return name[0].jw_unit;
      return '';
    }
  },
  computed: {
    zzManifestTypes() {
      const typeCdOption = this.$store.getters['options/options_tables'].zz_manifest_types ?? [];

      return typeCdOption.map(obj => ({
        text: obj.manifest_type,
        value: parseInt(obj.id)
      }));
    },
  },
}
</script>
<template>
  <Layout>
    <div class="d-flex justify-content-end mb-2">
      <b-button
        variant="primary"
        size="lg"
        @click="backToList()"
      >
        <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
      </b-button>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row class="mb-2">
          <div class="d-flex gap-2 col-6">
            <label class="text-nowrap col-form-label">2次マニフェスト番号</label>
            <b-form-input
              v-model="this.manifest2nd.number_of_issue"
              :disabled="true"
            />
          </div>
          <div class="d-flex gap-2 col-6">
            <label class="text-nowrap col-form-label">廃棄物種類</label>
            <b-form-input
              v-model="this.manifest2nd.waste_category_name"
              :disabled="true"
            />
          </div>
        </b-row>
        <b-row class="mb-2">
          <div class="d-flex gap-2 col-6">
            <label class="text-nowrap col-form-label">排出事業者加入番号</label>
            <b-form-input
              v-model="this.manifest2nd.discharger_registration_number"
              :disabled="true"
            />
          </div>
          <div class="d-flex gap-2 col-6">
            <label class="text-nowrap col-form-label">運搬先</label>
            <b-form-input
              v-model="this.manifest2nd.sub_disposal_vendor_name"
              :disabled="true"
            />
          </div>
        </b-row>
        <b-row class="mb-2">
          <div class="d-flex gap-2 col-6">
            <label class="text-nowrap col-form-label">処分事業者加入番号</label>
            <b-form-input
              v-model="this.manifest2nd.sub_disposal_vendor_registration_number"
              :disabled="true"
            />
          </div>
          <div class="d-flex gap-2 col-6">
            <label class="text-nowrap col-form-label">処分事業者事業場ID</label>
            <b-form-input
              v-model="this.manifest2nd.waste_or_service_daily_report[0].vendor_site_id"
              :disabled="true"
            />
          </div>
        </b-row>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <b-row class="mb-2">
          <b-col>
            <div class="d-flex gap-2">
            <label class="col-form-label text-nowrap">媒体</label>
            <b-form-radio-group
              class="d-flex gap-2 align-items-center mt-1"
              :options="zzManifestTypes"
              v-model="filters.manifest_type_cd"
            ></b-form-radio-group>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label class="col-form-label text-nowrap">排出事業者</label>
              <b-form-input
                v-model="filters.discharger_name"
                type="text"
                id="search-value-1"
              ></b-form-input>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label class="col-form-label text-nowrap">排出事業場</label>
              <b-form-input
                v-model="filters.discharger_site_name"
                type="text"
                id="search-value-2"
              ></b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="12">
            <div class="d-flex gap-2">
              <label class="col-form-label text-nowrap">処分事業場</label>
              <b-form-input
                v-model="filters.disposal_vendor_site_name"
                type="text"
                id="search-value-3"
              ></b-form-input>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col cols="6">
            <div class="d-flex gap-2">
              <label class="col-form-label text-nowrap">処分終了日</label>
              <div class="d-flex gap-3">
                <div>
                  <date-picker
                    lang="ja"
                    v-model="filters.start_datetime"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="left"
                    class="manifests-date-picker"
                  ></date-picker>
                </div>
                <div class="align-self-center">～</div>
                <div>
                  <date-picker
                    lang="ja"
                    v-model="filters.end_datetime"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="YYYY-MM-DD"
                    position="right"
                    class="manifests-date-picker"
                  ></date-picker>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <div class="d-flex align-items-center justify-content-center gap-2">
            <b-button class="button-search" variant="primary" size="lg" @click="onSearch()">
              <i class="fas fa-search"></i> {{ this.$lang.button.search }}
            </b-button>
            <b-button variant="dark" size="lg" @click="onClear()">
              <i class="fas fa-eraser"></i> {{ this.$lang.button.clear }}
            </b-button>
            <b-button class="button-select" variant="primary" size="lg" @click="onSelect()">
              <i class='fas fa-check'></i> {{ this.$lang.button.select }}
            </b-button>
          </div>
        </b-row>
      </div>
    </div>
    <b-row>
      <b-col cols="12">
        <div class="card">
          <div class="card-body">
            <b-overlay
              :show="isLoading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-100"
            >
              <CommonTableComponent :height-class="`table-wrapper-400`">
                  <thead class="table-light">
                  <tr>
                    <th
                      v-for="(item, index) in headers"
                      :style="`width: ${item.width}px`"
                      :key="index"
                    >
                      <span>{{ item.text }}</span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <template v-for="(item, index) in manifests">
                    <tr class="cursor-pointer">
                      <td class="text-center">
                        <b-form-checkbox
                          v-model="dataSelected"
                          :value="item.id"
                        />
                      </td>
                      <td class="">
                        <span>{{ item.number_of_issue }}</span>
                      </td>
                      <td class="text-center">
                        <span>{{ item.manifest_type_cd }}</span>
                      </td>
                      <td class="">
                        <span>{{ item.sub_disposal_vendor_disposal_amount }}</span>
                      </td>
                      <td class="">
                        <span>{{ getUnitName(item) }}</span>
                      </td>
                      <td class="">
                        <span>{{ item.sub_disposal_vendor_end_date }}</span>
                      </td>
                      <td class="manifests-sticky-column-5">
                        <span>{{ item.waste_name || ' ' }}</span>
                        <span>{{ item.waste_category_name }}</span>
                      </td>
                      <td class="manifests-sticky-column-6">
                        <span>{{ item.discharger_name }}</span>
                        <span>{{ item.discharger_site_name }}</span>
                      </td>
                      <td class="">
                        <span>{{ item.disposal_vendor_site_name }}</span>
                      </td>
                    </tr>
                  </template>
                  <template v-if="!manifests.length">
                    <tr>
                      <td :colspan="headers.length" class="text-center">
                        データなし。
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </CommonTableComponent>
            </b-overlay>
            <b-row>
              <div class="d-flex justify-content-center align-items-center gap-2 mt-2">
                <b-button variant="primary" size="lg" @click="onSelect()">
                  <i class='fas fa-check'></i> {{ this.$lang.button.select }}
                </b-button>
                <b-button variant="primary" size="lg" @click="backToList()">
                  <i class='far fa-arrow-alt-circle-left'></i> {{ this.$lang.button.back }}
                </b-button>
              </div>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>
  </Layout>
</template>
<style scoped>

.manifests-sticky-column-5 span,
.manifests-sticky-column-6 span {
  display: block;
}
.button-search {
    margin-left: auto;
}
.button-select {
    margin-left: auto;
}
</style>
